<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <vue-editor
            :class="input_class"
            v-bind="$attrs"
            v-bind:value="value"
            v-if="!_is_readonly"
            v-on="inputListeners"
        >
        </vue-editor>

        <span v-html="value" v-if="_is_readonly"></span>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";
import { VueEditor } from "vue2-editor";

export default {
    name: "OHtmlArea",
    components: { OFormGroup, VueEditor },
    mixins: [FormComponentMixin],
};
</script>

<style scoped></style>
